module.exports = __webpack_public_path__ + "static/media/icon_sale.c614cdf7.svg";